// extracted by mini-css-extract-plugin
module.exports = {"errorContainer":"_2oOr3YezvYN2otxCHvsbPS"};